export default __webpack_public_path__ + "a17e72aaa3a3c3089c6c9470d5e58b35.svg";